/* eslint-disable no-nested-ternary */
// import React, { useEffect, useState } from 'react'
// import { GetTeamGroupCapa } from 'hooks' // Adjust the import path
// // import { LoaderBar } from 'components'
// import { GroupService } from 'utility'
// import { ModalCapaGroupList } from 'page-components/group'
// import { useLocation } from 'react-router-dom'

// const CapaModal = ({ isOpen, onClose, selectedItem }) => {
//     const { data = [], loading } = GetTeamGroupCapa()
//     const [capaList, setCapaList] = useState([])
//     const [filter, setFilter] = useState({
//         PageNumber: 1,
//         PageSize: 10, // Default page size
//         IsCapa: true, // Filter to show only CAPA groups
//     }) // Tracks if API was called

//     useEffect(() => {
//         const fetchCapaList = async () => {
//             try {
//                 const result = await GroupService.getTeamGroupCapa(filter)
//                 setCapaList(result)
//             } catch (err) {
//                 console.error('Error processing CAPA:', err)
//             }
//         }

//         fetchCapaList()
//     }, [filter])

//     useEffect(() => {
//         if (!loading) {
//             console.log('Fetched Data:', data) // Log the fetched data
//         }
//     }, [data, loading])

//     if (!isOpen) return null

//     const pageChanged = pageNumber => {
//         setFilter(prevFilter => ({
//             ...prevFilter,
//             PageNumber: pageNumber,
//         }))
//     }

//     return (
//         <div
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
//             aria-modal="true"
//             role="dialog"
//             tabIndex={-1}
//         >
//             <div className="bg-white rounded-lg p-6 w-11/12 max-w-lg">
//                 <h2 className="text-xl font-semibold mb-4">
//                     CAPA Groups for {selectedItem?.TemplateName || 'Template'}
//                 </h2>

//                 {/* Modal Content with Fixed Height and Scroll */}
//                 <div className="max-h-96 overflow-y-auto">
//                     <ModalCapaGroupList
//                         data={capaList || []}
//                         pageChanged={pageChanged}
//                         filter={filter}
//                     />
//                 </div>

//                 <div className="mt-4 flex justify-end space-x-2">
//                     <button
//                         type="button"
//                         className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//                         onClick={onClose}
//                     >
//                         Close
//                     </button>
//                 </div>
//             </div>
//         </div>
//     )
// }
// const CapaModal = ({ isOpen, onClose, selectedItem }) => {
//     const { data = [], loading } = GetTeamGroupCapa()
//     const [capaList, setCapaList] = useState([])
//     const [filter, setFilter] = useState({
//         PageNumber: 1,
//         PageSize: 10,
//         IsCapa: true,
//     })
//     // const location = useLocation()

//     useEffect(() => {
//         const fetchCapaList = async () => {
//             try {
//                 const result = await GroupService.getTeamGroupCapa(filter)
//                 setCapaList(result)
//             } catch (err) {
//                 console.error('Error:', err)
//             }
//         }

//         fetchCapaList()
//     }, [filter])

//     useEffect(() => {
//         if (!loading) {
//             console.log('Fetched Data:', data)
//         }
//     }, [data, loading])

//     if (!isOpen) return null

//     const pageChanged = pageNumber => {
//         setFilter(prevFilter => ({
//             ...prevFilter,
//             PageNumber: pageNumber,
//         }))
//     }

//     return (
//         <div
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
//             aria-modal="true"
//             role="dialog"
//             tabIndex={-1}
//         >
//             <div className="bg-white rounded-lg p-6 w-11/12 max-w-lg">
//                 <h2 className="text-xl font-semibold mb-4">
//                     CAPA Groups for {selectedItem?.TemplateName}
//                 </h2>

//                 <div className="max-h-96 overflow-y-auto">
//                     <ModalCapaGroupList
//                         data={capaList}
//                         pageChanged={pageChanged}
//                         filter={filter}
//                     />
//                 </div>

//                 <div className="mt-4 flex justify-end space-x-2">
//                     <button
//                         type="button"
//                         className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//                         onClick={onClose}
//                     >
//                         Close
//                     </button>
//                 </div>
//             </div>
//         </div>
//     )
// }
// const CapaModal = ({ isOpen, onClose, selectedItem }) => {
//     const { data = [], loading } = GetTeamGroupCapa()
//     const [capaList, setCapaList] = useState([])
//     const [filter, setFilter] = useState({
//         PageNumber: 1,
//         PageSize: 10,
//         IsCapa: true,
//     })

//     useEffect(() => {
//         const fetchCapaList = async () => {
//             try {
//                 const result = await GroupService.getTeamGroupCapa(filter)
//                 setCapaList(result)
//             } catch (err) {
//                 console.error('Error:', err)
//             }
//         }

//         fetchCapaList()
//     }, [filter])

//     useEffect(() => {
//         if (!loading) {
//             console.log('Fetched Data:', data)
//         }
//     }, [data, loading])

//     if (!isOpen) return null

//     const pageChanged = pageNumber => {
//         setFilter(prevFilter => ({
//             ...prevFilter,
//             PageNumber: pageNumber,
//         }))
//     }

//     return (
//         <div
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
//             aria-modal="true"
//             role="dialog"
//             tabIndex={-1}
//             onClick={onClose} // Close modal when clicking outside
//         >
//             <div
//                 className="bg-white rounded-lg p-6 w-11/12 max-w-lg"
//                 onClick={e => e.stopPropagation()} // Prevent click from closing modal when clicking inside
//             >
//                 <h2 className="text-xl font-semibold mb-4">
//                     CAPA Groups for {selectedItem?.TemplateName}
//                 </h2>

//                 <div className="max-h-96 overflow-y-auto">
//                     <ModalCapaGroupList
//                         data={capaList}
//                         pageChanged={pageChanged}
//                         filter={filter}
//                     />
//                 </div>

//                 <div className="mt-4 flex justify-end space-x-2">
//                     <button
//                         type="button"
//                         className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//                         onClick={onClose}
//                     >
//                         Close
//                     </button>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default CapaModal
// import React, { useEffect, useState } from 'react'
// import { GroupService } from 'utility'
// import { ModalCapaGroupList } from 'page-components/group'

// const CapaModal = ({ isOpen, onClose, selectedItem }) => {
//     const [capaList, setCapaList] = useState([])

//     // Hardcoded TemplateId
//     // const hardcodedTemplateId = '74e5ee9f-505a-401c-863d-3d3c9b6995d6'

//     const [filter, setFilter] = useState({
//         PageNumber: 1,
//         PageSize: 10,
//         IsCapa: true,
//         TemplateId: null, // Set the hardcoded TemplateId initially
//     })

//     // Update filter TemplateId when selectedItem changes
//     useEffect(() => {
//         if (selectedItem && selectedItem.TemplateId) {
//             // Override TemplateId when a new selectedItem is set
//             setFilter(prevFilter => ({
//                 ...prevFilter,
//                 TemplateId: selectedItem.TemplateId,
//                 // TemplateId: hardcodedTemplateId,
//             }))
//         }
//     }, [selectedItem]) // Run when selectedItem changes

//     // Fetch data when modal opens and filter updates
//     useEffect(() => {
//         if (isOpen && filter.TemplateId) {
//             const fetchCapaList = async () => {
//                 try {
//                     const result = await GroupService.getTeamGroupCapa({
//                         ...filter, // Spread the filter to include all query params
//                     })
//                     // Sort by display_order before setting state
//                     const sortedResult = result.sort(
//                         (a, b) => a.display_order - b.display_order,
//                     )
//                     setCapaList(sortedResult)
//                 } catch (err) {
//                     console.error('Error fetching CAPA groups:', err)
//                 }
//             }

//             fetchCapaList()
//         }
//     }, [isOpen, filter])

//     if (!isOpen) return null

//     const pageChanged = pageNumber => {
//         setFilter(prevFilter => ({
//             ...prevFilter,
//             PageNumber: pageNumber,
//         }))
//     }

//     return (
//         <div
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
//             aria-modal="true"
//             role="dialog"
//             tabIndex={-1}
//             onClick={onClose}
//         >
//             <div
//                 className="bg-white rounded-lg p-6 w-11/12 max-w-lg"
//                 onClick={e => e.stopPropagation()}
//             >
//                 <h2 className="text-xl font-semibold mb-4">
//                     CAPA Groups for{' '}
//                     {selectedItem ? selectedItem.TemplateName : 'Template'}
//                 </h2>

//                 <div className="max-h-96 overflow-y-auto">
//                     <ModalCapaGroupList
//                         data={capaList}
//                         pageChanged={pageChanged}
//                         filter={filter}
//                     />
//                 </div>

//                 <div className="mt-4 flex justify-end space-x-2">
//                     <button
//                         type="button"
//                         className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//                         onClick={onClose}
//                     >
//                         Close
//                     </button>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default CapaModal
import React, { useEffect, useState } from 'react'
import { GetGroupList } from 'hooks'
import { GroupService } from 'utility/services/group'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { List, X } from 'phosphor-react'
import { FlexRowBetween } from 'components'

const CapaModal = ({ isOpen, onClose, selectedItem, selectedGroups }) => {
    const { data, loading } = GetGroupList()
    const [dropdowns, setDropdowns] = useState([{ id: 1, selectedGroup: null }])
    const [error, setError] = useState(null)
    const [templateId, setTemplateId] = useState(null)
    const [submittedGroups, setSubmittedGroups] = useState([])

    useEffect(() => {
        if (isOpen && !loading) {
            console.log('Modal opened and CAPA data fetched:', data)

            // Sort and initialize dropdowns
            const initializedDropdowns = selectedGroups
                .sort((a, b) => a.DisplayOrder - b.DisplayOrder)
                .map((group, index) => ({
                    id: index + 1,
                    selectedGroup: {
                        ...group,
                        TemplateId: selectedItem.TemplateId,
                    },
                }))

            // Ensure unique groups
            const uniqueDropdowns = initializedDropdowns.filter(
                (dropdown, index, self) =>
                    index ===
                    self.findIndex(
                        d =>
                            d.selectedGroup.GroupId ===
                            dropdown.selectedGroup.GroupId,
                    ),
            )

            setDropdowns(uniqueDropdowns)
            setSubmittedGroups(
                uniqueDropdowns.map(dropdown => dropdown.selectedGroup.GroupId),
            ) // Store submitted groups
        }
    }, [isOpen, loading, data, selectedItem, selectedGroups])

    useEffect(() => {
        if (isOpen && selectedItem) {
            // console.log(
            //     'Modal Opened with Template ID:',
            //     selectedItem.TemplateId,
            // )
            setTemplateId(selectedItem.TemplateId) // Set the ID in modal state
        }
    }, [isOpen, selectedItem])

    useEffect(() => {
        console.log('Dropdowns State Updated:', dropdowns)
    }, [dropdowns])

    if (!isOpen) return null

    // Filter out duplicate GroupIds and filter by IsCapa
    const uniqueData =
        data && Array.isArray(data)
            ? data.filter(
                  (value, index, self) =>
                      index ===
                          self.findIndex(t => t.GroupId === value.GroupId) &&
                      value.IsCapa === true,
              )
            : []

    // console.log('Unique Data:', uniqueData)

    const handleAddGroupClick = () => {
        const newDropdown = {
            id: dropdowns.length + 1,
            selectedGroup: null,
        }

        setDropdowns(prevDropdowns => [...prevDropdowns, newDropdown])
    }

    const handleGroupSelect = (dropdownId, selectedGroup) => {
        if (!selectedGroup) {
            console.error('No group selected')
            return
        }

        // Check if the selected group is already selected in another dropdown
        const isAlreadySelected = dropdowns.some(
            dropdown =>
                dropdown.id !== dropdownId &&
                dropdown.selectedGroup?.GroupId === selectedGroup.GroupId,
        )

        if (isAlreadySelected) {
            setError('This group is already selected in another dropdown.')
            return
        }

        const updatedGroup = { ...selectedGroup, TemplateId: templateId } // Set TemplateId

        console.log(
            'Updating Dropdown ID:',
            dropdownId,
            'with Group:',
            updatedGroup,
        )

        setDropdowns(prevDropdowns =>
            prevDropdowns.map(dropdown =>
                dropdown.id === dropdownId
                    ? { ...dropdown, selectedGroup: updatedGroup } // Store updated group
                    : dropdown,
            ),
        )

        setError(null) // Clear any previous error
    }

    const handleDragEnd = async result => {
        const { destination, source } = result
        if (!destination) return // Dropped outside

        const updatedDropdowns = Array.from(dropdowns)
        const [removed] = updatedDropdowns.splice(source.index, 1)
        updatedDropdowns.splice(destination.index, 0, removed)

        // Recalculate display order
        const reorderedWithOrderNumbers = updatedDropdowns.map(
            (dropdown, index) => ({
                ...dropdown,
                DisplayOrder: index + 1,
            }),
        )

        setDropdowns(reorderedWithOrderNumbers)

        // Prepare the payloads for each updated group
        const updates = reorderedWithOrderNumbers
            .map(dropdown => dropdown.selectedGroup)
            .filter(group => group !== null && group !== undefined)
            .map(group => ({
                MappingId: group.MappingId,
                GroupId: group.GroupId,
                DisplayOrder: reorderedWithOrderNumbers.find(
                    d => d.selectedGroup?.GroupId === group.GroupId,
                )?.DisplayOrder,
                TemplateId: templateId,
            }))

        if (updates.length === 0) {
            setError('Please select at least one group.')
            return
        }

        try {
            // Run the API for each group separately
            await Promise.all(
                updates.map(async payload => {
                    const response = await GroupService.updateTeamGroupCapa(
                        payload,
                        templateId,
                    )
                    console.log('CAPA group updated:', response)
                }),
            )
        } catch (error) {
            setError('Failed to update CAPA groups. Please try again.')
        }
    }

    const handleSubmit = async () => {
        const selectedGroups = dropdowns
            .map((dropdown, index) => ({
                ...dropdown.selectedGroup,
                DisplayOrder: index + 1, // Recalculate DisplayOrder
            }))
            .filter(group => group !== null && group !== undefined)

        console.log('Selected Groups:', selectedGroups)

        if (selectedGroups.length === 0) {
            setError('Please select at least one group.')
            return
        }

        // Filter out already submitted groups
        const newGroups = selectedGroups.filter(
            group => !submittedGroups.includes(group.GroupId),
        )

        if (newGroups.length === 0) {
            setError('No new groups to submit.')
            return
        }

        try {
            await Promise.all(
                newGroups.map(async group => {
                    const payload = {
                        templateId: selectedItem?.TemplateId,
                        GroupId: group.GroupId,
                        DisplayOrder: group.DisplayOrder,
                    }

                    const response = await GroupService.insertTeamGroupCapa(
                        payload,
                    )
                    console.log('CAPA group inserted:', response)
                }),
            )

            setSubmittedGroups(prev => [
                ...prev,
                ...newGroups.map(g => g.GroupId),
            ]) // Add newly submitted groups to state
            onClose()
        } catch (error) {
            setError('Failed to insert CAPA groups. Please try again.')
        }
    }

    const handleRemoveGroup = async groupId => {
        if (!groupId) {
            setError('No group selected to remove.')
            return
        }

        console.log('Attempting to remove group with MappingId:', groupId)

        try {
            const response = await GroupService.removeTeamGroupCapaByMappingId(
                groupId,
            )
            console.log('CAPA group removed successfully:', response)

            // Remove from dropdowns
            const updatedDropdowns = dropdowns.filter(
                dropdown => dropdown.selectedGroup?.MappingId !== groupId,
            )

            // Update submittedGroups state by removing the deleted group
            setSubmittedGroups(prev => prev.filter(id => id !== groupId))

            // Recalculate DisplayOrder
            const reorderedDropdowns = updatedDropdowns.map(
                (dropdown, index) => ({
                    ...dropdown,
                    selectedGroup: {
                        ...dropdown.selectedGroup,
                        DisplayOrder: index + 1,
                    },
                }),
            )

            setDropdowns(reorderedDropdowns)

            // Optionally update backend with new DisplayOrder
            await Promise.all(
                reorderedDropdowns.map(async dropdown => {
                    const payload = {
                        MappingId: dropdown.selectedGroup.MappingId,
                        GroupId: dropdown.selectedGroup.GroupId,
                        DisplayOrder: dropdown.selectedGroup.DisplayOrder,
                        TemplateId: templateId,
                    }
                    await GroupService.updateTeamGroupCapa(payload, templateId)
                }),
            )
        } catch (error) {
            console.error('Error removing CAPA group:', error)
            setError('Failed to remove CAPA group. Please try again.')
        }
    }

    const getFilteredData = dropdownId => {
        const selectedGroupIds = dropdowns
            .filter(dropdown => dropdown.id !== dropdownId)
            .map(dropdown => dropdown.selectedGroup?.GroupId)
            .filter(Boolean)
        // console.log(
        //     'Selected Group IDs (excluding current dropdown):',
        //     selectedGroupIds,
        // )

        return uniqueData.filter(
            group => !selectedGroupIds.includes(group.GroupId),
        )
    }
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            aria-modal="true"
            role="dialog"
            tabIndex={-1}
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg p-6 w-11/12 max-w-lg"
                onClick={e => e.stopPropagation()}
            >
                <FlexRowBetween>
                    <h2 className="text-xl font-semibold mb-4">
                        CAPA Groups for {selectedItem?.TemplateName}
                    </h2>
                    <X className="pointer" size={32} onClick={onClose} />
                </FlexRowBetween>

                {error && <p className="text-red-500 mb-4">{error}</p>}

                <button
                    type="button"
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mb-4"
                    onClick={handleAddGroupClick}
                >
                    Add Group
                </button>

                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="droppable">
                        {provided => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className="space-y-2 max-h-96 overflow-y-auto"
                            >
                                {dropdowns.map((dropdown, index) => (
                                    <Draggable
                                        key={dropdown.id}
                                        draggableId={`dropdown-${dropdown.id}`}
                                        index={index}
                                    >
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                className={`p-3 border rounded shadow-sm ${
                                                    snapshot.isDragging
                                                        ? 'bg-gray-100'
                                                        : ''
                                                }`}
                                                style={{
                                                    ...provided.draggableProps
                                                        .style,
                                                }}
                                            >
                                                <div className="flex items-center space-x-10">
                                                    <div
                                                        className="cursor-pointer"
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <List />
                                                    </div>
                                                    <div className="space-y-1 w-full">
                                                        <select
                                                            className="w-full p-2 border rounded mb-2 max-h-[50px] overflow-y-auto border-gray-300 "
                                                            value={
                                                                dropdown
                                                                    .selectedGroup
                                                                    ?.GroupId ||
                                                                ''
                                                            }
                                                            onChange={e => {
                                                                const selectedGroup =
                                                                    uniqueData.find(
                                                                        group =>
                                                                            String(
                                                                                group.GroupId,
                                                                            ) ===
                                                                            String(
                                                                                e
                                                                                    .target
                                                                                    .value,
                                                                            ),
                                                                    )
                                                                console.log(
                                                                    'Dropdown ID:',
                                                                    dropdown.id,
                                                                    'Selected Value:',
                                                                    e.target
                                                                        .value,
                                                                    'Selected Group:',
                                                                    selectedGroup,
                                                                ) // Debugging log
                                                                handleGroupSelect(
                                                                    dropdown.id,
                                                                    selectedGroup,
                                                                )
                                                            }}
                                                        >
                                                            <option
                                                                value=""
                                                                disabled
                                                            >
                                                                Select a CAPA
                                                                group
                                                            </option>
                                                            {getFilteredData(
                                                                dropdown.id,
                                                            ).map(group => (
                                                                <option
                                                                    key={
                                                                        group.GroupId
                                                                    }
                                                                    value={
                                                                        group.GroupId
                                                                    }
                                                                >
                                                                    {
                                                                        group.GroupName
                                                                    }
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {dropdown.selectedGroup && (
                                                            <button
                                                                type="button"
                                                                className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                                                                onClick={() =>
                                                                    handleRemoveGroup(
                                                                        dropdown
                                                                            .selectedGroup
                                                                            .MappingId,
                                                                    )
                                                                }
                                                            >
                                                                Remove
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

                <button
                    type="button"
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                    onClick={handleSubmit}
                >
                    Submit
                </button>

                <div className="mt-4 flex justify-end space-x-2">
                    <button
                        type="button"
                        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CapaModal
